import { styled, TextField as TextFieldMui } from "@mui/material";

export const TextField = styled(TextFieldMui)(({ theme }) =>
    theme.unstable_sx({
        width: "100%",
        position: "relative",
        "&::before": {
            content: `""`,
            display: "block",
            height: 12,
            width: 16,
            position: "absolute",
            background: theme.palette.common.white,
            right: -1,
            top: -1,
            zIndex: 1,
        },
        "& .MuiOutlinedInput-root": {
            border: `1px solid ${theme.palette.grey[400]}`,
            borderRadius: 2,
            width: "100%",
        },
        "& .MuiOutlinedInput-root.Mui-focused": {
            borderColor: theme.palette.grey[800],
        },
        "& .MuiOutlinedInput-root..Mui-disabled": {
            borderColor: theme.palette.grey[400],
        },
        "& .MuiOutlinedInput-root.Mui-disabled input": {
            color: theme.palette.grey[400],
        },
        "& .MuiOutlinedInput-root>fieldset.MuiOutlinedInput-notchedOutline": {
            border: 0,
        },
    }),
);
